<!-- 
System logs listing page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="System logs"
      user-guide-topic="administration-system-logs"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="criteria.description"
        label="Description" 
        field="description" 
        @changed="$refs.listing.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search system logs"
        show-all
        @changed="$refs.listing.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        @selected="$refs.listing.refresh()"
      />
    </our-search-bar>
    <system-log-listing 
      ref="listing" 
      endpoint="/api/system-logs" 
      export-endpoint="/api/exports/system-logs" 
      export-validate-endpoint="/api/exports/validate/system-logs" 
    />
  </div>
</template>

<script>
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "SystemLogs",
  components: { SystemLogListing },
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      breadcrumbs: [{ text: "System logs" }]
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
